/**
 * Returns the client-id meta tag value
 */
export default function getClientId() {
  const clientIdTag = document.head.querySelector('meta[name=client-id]');
  return clientIdTag && clientIdTag.content;
}
